import i18n from 'i18next';
import { store } from 'src/store/store';
import { plusSubscriptionSlice } from 'src/store/plusSubscription/slice';
import { PlusSubscriptionModalPayloadActionType } from 'src/models/store/plusSubscription';
import { SafeAnyType } from 'src/utils/safeAny';

type OptionsType = Omit<PlusSubscriptionModalPayloadActionType['payload'], 'type'>;

export const showPlusSubscriptionModal = (
  type: PlusSubscriptionModalPayloadActionType['payload']['type'],
  options: OptionsType = { canClose: false }
): void => {
  const currentType = store.getState().plusSubscription.modal.type;
  const moreImportantModalTypes = ['planSelection'];

  if (currentType && moreImportantModalTypes.includes(currentType) && !moreImportantModalTypes.includes(type)) {
    return;
  }

  /**
   * load the namespace first in order to not make the screen blink (while loading NS)
   */
  i18n.loadNamespaces('plusSubscription', () => {
    store.dispatch<SafeAnyType>(plusSubscriptionSlice.actions.showModal({ type, ...options }));
  });
};

export const showPlanSelectionModal = () => showPlusSubscriptionModal('planSelection', { canClose: true });

export const closePlusSubscriptionModal = (): void => {
  store.dispatch(plusSubscriptionSlice.actions.closeModal());
};
